import { Geolocation } from '@capacitor/geolocation';
import { NativeGeocoder } from '@awesome-cordova-plugins/native-geocoder';

import { IGeoLocationService } from '..';
import { ST } from 'types';

class W3CGeoLocator implements IGeoLocationService {
  destroy() {}

  async getCurrentLocation(): Promise<ST.Location> {
    const pos = await Geolocation.getCurrentPosition();
    return { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
  }

  async getAddressFromLocation(pos: ST.Location): Promise<string> {
    const result = await NativeGeocoder.reverseGeocode(
      pos.latitude!,
      pos.longitude!,
      {
        maxResults: 1,
        useLocale: true,
      }
    ).catch(() => []);
    if (!result.length) return 'Unbekannt';
    const location = result[0];
    return `${location.thoroughfare}, ${location.locality}`;
  }
}

export default W3CGeoLocator;
